import { Seo } from 'components/Seo';
import { useParams } from 'react-router-dom';

export default function InfoSite(){
  let params = useParams();
  return (
    <><Seo title="Infoside" /><iframe src={'https://www.1881.no/tlf/mkas_' + params.id} title="Frima Infoside"></iframe></>
    
  )
}